import { createIcon } from "@chakra-ui/react";

export const Thinking = createIcon({
  displayName: "Thinking",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#yaatcw3xva)">
      <path
        fill="currentColor"
        d="M12 20.125a8.124 8.124 0 0 0 8.125-8.124A8.124 8.124 0 0 0 12 3.875a8.124 8.124 0 0 0-7.875 10.126 2.184 2.184 0 0 0-.875 1.75v1.093A9.94 9.94 0 0 1 2 12C2 6.478 6.477 2 12 2s10 4.477 10 10c0 5.524-4.477 10-10 10a9.8 9.8 0 0 1-1.227-.074c.157-.222.286-.468.383-.734l.395-1.082c.148.008.3.012.453.012l-.004.003zm1.68-6.207c-.387-.078-.801-.05-1.2.098l-1.187.445-2.559-.601a.624.624 0 1 1 .286-1.215l3.793.89c.32.075.613.208.87.383h-.003zM7.64 9.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0zm7.5-.625a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm-4.687-1.218a2.5 2.5 0 0 0-2.867-.274l-.277.157a.623.623 0 0 1-.852-.235.623.623 0 0 1 .234-.851l.278-.157a3.752 3.752 0 0 1 4.3.41l.516.442a.626.626 0 1 1-.816.95l-.516-.442zM6.375 15.75v1.891l6.547-2.453a.936.936 0 1 1 .66 1.754l-2.563.957c-.003.016-.011.031-.015.047l-1.027 2.82a1.872 1.872 0 0 1-1.762 1.235h-1.84A1.876 1.876 0 0 1 4.5 20.124v-4.374c0-.52.418-.938.938-.938.519 0 .937.418.937.938z"
      />
    </g>,
    <defs>
      <clipPath id="yaatcw3xva">
        <path fill="#fff" transform="translate(2 2)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  ],
  defaultProps: {
    "aria-label": "Thinking emoji"
  }
});

export default Thinking;
